import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useMemo, useState } from "react";
import {
  deleteOrganisationDepartment,
  deleteOrganisationDepartmentSuccess,
  getOrganisationDepartmentData,
  getOrganisationDepartmentList,
  searchOrganisationDepartmentToStaff,
} from "../../../../../store/staff/action";

import LocalDataSearch from "../../../../../Components/SearchAndFilter";
import LoadingSpinner from "../../../../../Components/Common/Spinner";
import TableContainer from "../../../../../Components/Common/TableContainer";

import { Col, Input, Row } from "reactstrap";
import { isEmpty } from "lodash";
import HandleDateTime from "../../../../../Components/Common/HandleDateTime";
import CreateEditDepartment from "../../../../../Components/popUpComponents/CreateEditDepartment";
import DeleteModal from "../../../../../Components/Common/DeleteModal";
import { toast } from "react-toastify";
import Select from "react-select";
import { Link } from "react-router-dom";
import CreateEditDepartmentToStaff from "../../../../../Components/popUpComponents/CreateEditDepartmentToStaff";

const DepartmentDetails = ({ selectedDepartment }) => {
  console.log("selectedDepartment", selectedDepartment);
  const dispatch = useDispatch();
  const [localDepartmentId, setLocalDepartmentId] = useState(null);
  console.log("localDepartmentId", localDepartmentId);

  useEffect(() => {
    if (selectedDepartment === null) return;
    setLocalDepartmentId(selectedDepartment);
  }, [selectedDepartment]);

  useEffect(() => {
    if (localDepartmentId === null) return;
    dispatch(
      searchOrganisationDepartmentToStaff([
        {
          organisationdepartment_data: {
            Id: localDepartmentId,
          },
        },
      ])
    );
  }, [localDepartmentId]);

  const {
    searchOrganisationDepartmentToStaffSuccessAPI,
    loadingSearchOrganisationDepartmentToStaff,
  } = useSelector((state) => ({
    searchOrganisationDepartmentToStaffSuccessAPI:
      state.Staff.searchOrganisationDepartmentToStaffSuccess
        ?.organisationdepartmenttostaff_list,
    loadingSearchOrganisationDepartmentToStaff:
      state.Staff.loadingSearchOrganisationDepartmentToStaff,
  }));
  console.log(
    "organisationDepartmentListAPI",
    searchOrganisationDepartmentToStaffSuccessAPI
  );
  const [allowedSearchFilters, setAllowedSearchFilters] = useState([
    "Id",
    "Name",
    "Staff_FullName",
    "JobStatus_Name",
    "Customer_FullName",
    "CustomerReference",
  ]);

  const allowedFiltersInit = [
    {
      useThisFilter: true,
      filterTitle: "Created Date Range",
      filterType: "DateRange",
      filterProperty: "CreatedDateTime",
      filterValue: {
        startDate: "",
        endDate: "",
      },
    },
  ];
  const [allowedFilters, setAllowedFilters] = useState(allowedFiltersInit);
  const [showFilter, setShowFilter] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchData, setSearchData] = useState([]);
  const [searchInActionShowLoading, setSearchInActionShowLoading] =
    useState(false);
  const toggleShowFilter = () => {
    setShowFilter(!showFilter);
  };

  const columns = useMemo(
    () => [
      {
        // job id  with beginning #Job_Id
        Header: "Id",
        accessor: "Id",
        filterable: false,
        Cell: (jobs) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1 ms-2 name">
                <span className={"like-href"}> #{jobs.row.original.Id}</span>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: "Staff",
        accessor: "Staff_FullName",
        filterable: true,
        Cell: (jobs) => (
          <>
            <div className="d-flex align-items-center">
              <Link
                to={`/staff-details/${jobs.row.original?.Staff_Id}/Overview`}
              >
                <div className="flex-grow-1 ms-2 name">
                  <div className={"staff-avatar-and-name-container"}>
                    {jobs.row.original?.Staff_ImageUrl ? (
                      <div>
                        <img
                          src={jobs.row.original?.Staff_ImageUrl}
                          alt=""
                          className="img-fluid rounded-circle avatar-xxs"
                        />
                        <span> {jobs.row.original?.Staff_FullName}</span>
                      </div>
                    ) : (
                      <div className={"staff-avatar-and-name-container"}>
                        <span
                          className="
                            avatar-title avatar-xxs
                            rounded-circle bg-soft-primary
                             text-primary
                             Staff-single-letter-avatar
                              "
                        >
                          {jobs.row.original?.Staff_FullName.charAt(0)}
                        </span>
                        <span> {jobs.row.original?.Staff_FullName}</span>
                      </div>
                    )}
                  </div>
                </div>
              </Link>
            </div>
          </>
        ),
      },

      {
        Header: "Job Title",
        accessor: (row) => {
          return <div>{row?.Staff_JobTitle}</div>;
        },
        filterable: false,
      },
      {
        Header: "Job Role",
        accessor: (row) => {
          return <div>{row?.FlagManager === "1" ? "Manager" : "Staff"}</div>;
        },
        filterable: false,
      },
      {
        Header: "Start Date",
        accessor: (row) => {
          return <div>{HandleDateTime(row?.StartDateTime)}</div>;
        },
        filterable: false,
      },
      {
        Header: "End Date",
        accessor: (row) => {
          //CreatedDateTime sort date so its day Month name Year and time

          return (
            <div>{row?.EndDateTime && HandleDateTime(row?.EndDateTime)}</div>
          );

          // return row.CreatedDateTime
        },
        filterable: false,
      },
      {
        Header: "Create On",
        accessor: (row) => {
          //CreatedDateTime sort date so its day Month name Year and time

          return <div>{HandleDateTime(row?.CreatedDateTime)}</div>;

          // return row.CreatedDateTime
        },
        filterable: false,
      },
      // {
      //   Header: "Action",
      //   Cell: (cellProps) => {
      //     return (
      //       <UncontrolledDropdown>
      //         <DropdownToggle
      //           className="btn btn-soft-info btn-icon fs-14"
      //           type="button"
      //           id="dropdownMenuButton1"
      //           data-bs-toggle="dropdown"
      //           aria-expanded="false"
      //         >
      //           <i className="fa-solid fa-ellipsis"></i>
      //         </DropdownToggle>
      //         <DropdownMenu>
      //           <li>
      //             <DropdownItem>
      //               <div
      //                 className="edit-item-btn"
      //                 onClick={() => {
      //                   handleUpdate(cellProps.row.original.Id);
      //                 }}
      //               >
      //                 <div className={"job-settings-buttons"}>
      //                   <i className="ri-pencil-fill align-center text-muted"></i>
      //                   <span> Edit</span>
      //                 </div>
      //               </div>
      //             </DropdownItem>
      //           </li>
      //
      //           <li>
      //             <DropdownItem>
      //               <div
      //                 className="remove-item-btn"
      //                 onClick={() => {
      //                   handlePreDelete(cellProps.row.original.Id);
      //                 }}
      //               >
      //                 <div className={"job-settings-buttons"}>
      //                   <i className="ri-delete-bin-fill align-center text-muted"></i>{" "}
      //                   <span> Delete</span>
      //                 </div>
      //               </div>
      //             </DropdownItem>
      //           </li>
      //         </DropdownMenu>
      //       </UncontrolledDropdown>
      //     );
      //   },
      // },
    ],
    [searchData]
  );
  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const { singleOrganisationDepartmentDataAPI } = useSelector((state) => ({
    singleOrganisationDepartmentDataAPI:
      state.Staff.singleOrganisationDepartmentData?.organisationdepartment_data,
  }));

  const toggle = () => {
    setModal(!modal);
  };


  const [deleteModal, setDeleteModal] = useState(false);
  const [itemToBeDeleted, setItemToBeDeleted] = useState(null);

  const executeDelete = () => {
    dispatch(deleteOrganisationDepartment(itemToBeDeleted));
  };
  const { deleteOrganisationDepartmentSuccessAPI } = useSelector((state) => ({
    deleteOrganisationDepartmentSuccessAPI:
      state.Staff.deleteOrganisationDepartmentSuccess,
  }));

  useEffect(() => {
    if (isEmpty(deleteOrganisationDepartmentSuccessAPI)) return;
    if (deleteOrganisationDepartmentSuccessAPI?.status === 200) {
      toast.success(deleteOrganisationDepartmentSuccessAPI?.message);
      dispatch(getOrganisationDepartmentList());
      setDeleteModal(false);
      setItemToBeDeleted(null);
    } else {
      toast.error(deleteOrganisationDepartmentSuccessAPI?.message);
    }
    dispatch(deleteOrganisationDepartmentSuccess([]));
  }, [deleteOrganisationDepartmentSuccessAPI]);

  const { organisationDepartmentListAPI } = useSelector((state) => ({
    organisationDepartmentListAPI:
      state.Staff.organisationDepartmentList?.organisationdepartment_list,
  }));
  useEffect(() => {
    if (isEmpty(organisationDepartmentListAPI)) return;
    if (selectedDepartment === null) {
      setLocalDepartmentId(organisationDepartmentListAPI[0].Id);
    }
  }, [organisationDepartmentListAPI]);
  return (
    <div>
      {deleteModal && (
        <DeleteModal
          show={deleteModal}
          onDeleteClick={executeDelete}
          onCloseClick={() => setDeleteModal(false)}
        />
      )}
      {modal && (
        <CreateEditDepartmentToStaff
          modal={modal}
          setModal={setModal}
          toggle={toggle}
          isEdit={isEdit}
          updateData={singleOrganisationDepartmentDataAPI}
        />
      )}
      <LocalDataSearch
        Page={""}
        ReceivedDataAPI={searchOrganisationDepartmentToStaffSuccessAPI}
        setSearchInActionShowLoading={setSearchInActionShowLoading}
        allowedSearchFilters={allowedSearchFilters}
        searchQuery={searchQuery}
        setSearchFilteredResults={setSearchData}
        showFilter={showFilter}
        setShowFilter={setShowFilter}
        toggleShowFilter={toggleShowFilter}
        allowedFiltersInit={allowedFiltersInit}
        allowedFilters={allowedFilters}
        setAllowedFilters={setAllowedFilters}
      />
      <div>
        <div className={"p-2"}>
          <Row className="g-4 align-items-center">
            <Col lg={4}>
              <div className={"d-flex"}>
                <div className="search-box w-100">
                  <Select
                    className="select-search-box"
                    value={
                      localDepartmentId
                        ? {
                            value: localDepartmentId,
                            label: organisationDepartmentListAPI?.find(
                              (department) =>
                                department?.Id === localDepartmentId
                            )?.Name,
                          }
                        : []
                    }
                    onChange={(e) => {
                      setLocalDepartmentId(e.value);
                    }}
                    options={
                      !isEmpty(organisationDepartmentListAPI)
                        ? organisationDepartmentListAPI?.map((department) => {
                            return {
                              value: department?.Id,
                              label: department?.Name,
                            };
                          })
                        : []
                    }
                  ></Select>
                </div>
              </div>
            </Col>
            <Col lg={4}>
              <div className={"d-flex"}>
                <div className="search-box">
                  <Input
                    // create search with jobs List Data
                    type="search"
                    className="form-control search"
                    placeholder="Search for..."
                    onChange={(e) => {
                      setSearchQuery(e.target.value);
                    }}
                    value={searchQuery}
                  />
                  <i className="ri-search-line search-icon"></i>
                </div>
              </div>
            </Col>
            <div className="col-sm-auto ms-auto">
              <div className="hstack gap-2">
                {/*<button*/}
                {/*  type="button"*/}
                {/*  className="btn btn-info btn-info-filters"*/}
                {/*  onClick={() => toggleShowFilter()}*/}
                {/*>*/}
                {/*  <i className="ri-filter-3-line align-bottom me-1"></i> Filters*/}
                {/*</button>*/}
                <button
                  type="button"
                  className="btn btn-success add-btn btn-info-add-jobs"
                  id="create-btn"
                  onClick={() => {
                    setIsEdit(false);
                    setModal(true);
                  }}
                >
                  <i className="ri-add-line align-bottom me-1"></i>
                  Assign Staff to Department
                </button>
              </div>
            </div>
          </Row>
          {loadingSearchOrganisationDepartmentToStaff ? (
            <LoadingSpinner />
          ) : (
            <>
              {searchData?.length > 0 ? (
                <TableContainer
                  columns={columns}
                  data={searchData}
                  isGlobalFilter={false}
                  isAddUserList={false}
                  customPageSize={10}
                  className="custom-header-css"
                  divClass="table-responsive table-card mb-0"
                  tableClass="align-middle table-wrapper-scroll-y my-custom-scrollbar"
                  theadClass="text-muted"
                  isLeadsFilter={false}
                />
              ) : (
                <div>
                  <div className="text-center">
                    <h2>No results</h2>
                    <p className="text-muted">
                      There are no data available or try new search query.
                    </p>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default DepartmentDetails;
